import { View } from "react-native";
import { HorizBox, Narrow, PadBox } from "component/basics";
import { AskForPermissionScreen, AskForPermissionScreenProps, PermissionPopupContent } from "open-modules/zdf/component/notifications/push-notification";
import { DemoSection } from "system/demo";
import { Heading, TextField } from "component/text";
import { CTAButton } from "component/button";
import { callServerApiAsync } from "system/servercall";
import { useDatastore } from "util/datastore";
import { useState } from "react";
import { Banner } from "component/banner";
import { FormField } from "component/form";
import { colorTeaserBackground } from "component/color";
import { useIsAdmin } from "component/admin";
import { dropKey } from "util/util";

export function PushNotificationDemo() {
    return <Narrow>
        <SendTestNotification />
        <DemoSection text={"Permission Popup"}>
            <PermissionPopupContent/>
        </DemoSection>
        <DemoSection text={"Permission Popup with warning that browser notifications are disabled"}>
            <PermissionPopupContent permission={"denied"}/>
        </DemoSection>
        <DemoSection text={"Ask for permission sub screens"}>
            <AskForPermissionDemos />
        </DemoSection>
    </Narrow>;
}

function SendTestNotification() {
    const datastore = useDatastore()
    const isAdmin = useIsAdmin()

    const [link, setLink] = useState(window.location.protocol + '//' + window.location.host);
    const [title, setTitle] = useState("Test Title");
    const [body, setBody] = useState("Test Body");

    const sendTest = (delay = 0) => {
        callServerApiAsync({
            datastore, component: "pushNotifications", funcname: "sendTestNotification", params: {
                delay: delay,
                link,
                title,
                body
            }
        })
    }

    if(!isAdmin){
        return null
    }
    
    return <Banner color={colorTeaserBackground}>
        <Heading text={"Send a test notification to yourself"} />
        <View>
            <FormField text={"Title"}>
                <TextField value={title} onChange={setTitle} noTranslationPlaceholder={"Custom Link"} multiline={false}/>
            </FormField>
            <FormField text={"Body"}>
                <TextField value={body} onChange={setBody} noTranslationPlaceholder={"Custom Link"} multiline={false}/>
            </FormField>
            <FormField text={"Link"}>
                <TextField value={link} onChange={setLink} noTranslationPlaceholder={"Custom Link"} multiline={false}/>
            </FormField>
        </View>
        <HorizBox spread>
            <CTAButton text={"Send now"} onPress={() => sendTest(0)} />
            <CTAButton text={"Send after 5 seconds"} onPress={() => sendTest(5000)} />
        </HorizBox>
    </Banner>
}

const askForPermissionVariants: (AskForPermissionScreenProps & {key: string, text: string})[] = [
    {key: "default", text: "Default (loading)", permission: "default", already: false, loading: true},
    {key: "defaultCancelled", text: "Default (dialog cancelled)", permission: "default", already: false, loading: false},
    {key: "granted", text: "Granted (After confirm)", permission: "granted", already: false, loading: false},
    {key: "grantedAlready", text: "Granted (Already by browser)", permission: "granted", already: true, loading: false},
    {key: "denied", text: "Denied", permission: "denied", already: false, loading: false},
    {key: "error", text: "Error", permission: "default", already: false, loading: false, error: true}
]

function AskForPermissionDemos () {
    return <View>
        {askForPermissionVariants.map(option => <PadBox vert={16} key={option.key}>
            <Heading text={option.text} />
            <AskForPermissionScreen {...dropKey(option)} key={option.key}/>
        </PadBox>)}
    </View>
}